import React from 'react';
import { Form } from '@servicetitan/design-system';
import { signatureContainer } from 'src/signature/ioc';
import { SignModalStore } from 'src/signature/stores/sign-modal.store';

interface SignatureTextProps {
    value: string;
    onChange: (
        _0: React.SyntheticEvent<HTMLInputElement, Event>,
        data: {
            value: string;
        }
    ) => void;
    error: boolean;
}

export const SignatureText: React.FC<SignatureTextProps> = React.memo(
    ({ value, onChange, error }) => {
        const { isLoading } = signatureContainer.get(SignModalStore)!;

        return (
            <Form className="m-t-3">
                <Form.Input
                    autoFocus
                    fluid
                    type="text"
                    label="Signature"
                    placeholder="John Smith"
                    value={value}
                    disabled={isLoading}
                    error={error}
                    onChange={onChange}
                />
            </Form>
        );
    }
);
